<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="value.parameter1"
          label="Update Current Row"
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <TablePicker v-model="value.parameter2" title="Data Table" />
      </v-col>
      <v-col cols="12">
        <ServerFieldValueListEditor
          title="Target Columns"
          v-model="value.values"
          :table="value.parameter2"
        />
      </v-col>
      <v-col cols="12">
        <ServerFilterEditor v-model="value.filters" :table="value.parameter1" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../../ui/shared/TablePicker.vue";
import ServerFieldValueListEditor from "../../ui/shared/ServerFieldValueListEditor.vue";
import ServerFilterEditor from "../../ui/shared/ServerFilterEditor.vue";

export default {
  name: "UpdateRowDesigner",

  components: { TablePicker, ServerFieldValueListEditor, ServerFilterEditor },

  props: ["value"],
};
</script>